var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgXTwitter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M18.243 2.25h3.31l-7.228 8.26 8.503 11.24h-6.656l-5.218-6.816-5.962 6.816H1.678l7.73-8.836L1.255 2.25H8.08l4.71 6.23zm-1.162 17.522h1.833L7.082 4.125H5.114z"
})));
export default SvgXTwitter;